<template>
  <div class="currency-setting-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="item item2">
          <div class="title">团队等级升级条件设置</div>
          <div class="form">
            <div class="input-box">
              <div class="label">社区代理:</div>
              <div class="item-input">
                <div>
                  <span>直推分享（数量）个有效账户</span
                  ><input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info1.oneDirectVip"
                    style="margin-right: 12px"
                  />
                </div>
                <div style="margin-top: 12px">
                  <span>团队达到（数量）个有效账户</span
                  ><input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info1.oneDirectTeam"
                    style="margin-right: 12px"
                  />
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
            <div class="input-box">
              <div class="label">区县代理:</div>
              <div class="item-input">
                <div>
                  <span>三条线各有（数量）个（身份）</span
                  ><input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info1.twoNumber"
                    style="margin-right: 12px"
                  />
                  <el-select
                    v-model.number="info1.twoRole"
                    size="small"
                    class="select"
                    style="width: 160px"
                    placeholder="身份"
                  >
                    <el-option
                      v-for="item in role"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
            <div class="input-box">
              <div class="label">市级代理:</div>
              <div class="item-input">
                <div>
                  <span>三条线各有（数量）个（身份）</span
                  ><input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info1.threeNumber"
                    style="margin-right: 12px"
                  />
                  <el-select
                    v-model.number="info1.threeRole"
                    size="small"
                    class="select"
                    style="width: 160px"
                    placeholder="身份"
                  >
                    <el-option
                      v-for="item in role"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
            <div class="input-box">
              <div class="label">运营中心:</div>
              <div class="item-input">
                <div>
                  <span>三条线各有（数量）个（身份）</span
                  ><input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info1.fourNumber"
                    style="margin-right: 12px"
                  />
                  <el-select
                    v-model.number="info1.fourRole"
                    size="small"
                    class="select"
                    style="width: 160px"
                    placeholder="身份"
                  >
                    <el-option
                      v-for="item in role"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
          </div>
          <div class="btn" @click="setOption1()">保存设置</div>
        </div>
        <div class="item item2">
          <div class="title">开通人数限制设置</div>
          <div class="form">
            <div class="input-box">
              <div class="label">VIP会员数量:</div>
              <div class="item-input">
                <div>
                  <input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info2.roleOne"
                    style="margin-right: 12px"
                  />
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
            <div class="input-box">
              <div class="label">三级消费商数量:</div>
              <div class="item-input">
                <div>
                  <input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info2.roleTwo"
                    style="margin-right: 12px"
                  />
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
            <div class="input-box">
              <div class="label">二级消费商数量:</div>
              <div class="item-input">
                <div>
                  <input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info2.roleThree"
                    style="margin-right: 12px"
                  />
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
            <div class="input-box">
              <div class="label">一级消费商数量:</div>
              <div class="item-input">
                <div>
                  <input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info2.roleFour"
                    style="margin-right: 12px"
                  />
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
            <div class="input-box">
              <div class="label">合伙人数量:</div>
              <div class="item-input">
                <div>
                  <input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info2.stockFive"
                    style="margin-right: 12px"
                  />
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
            <div class="input-box">
              <div class="label">创始人数量:</div>
              <div class="item-input">
                <div>
                  <input
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model.number="info2.stockSix"
                    style="margin-right: 12px"
                  />
                </div>
                <!-- <div class="tip"></div> -->
              </div>
            </div>
          </div>
          <div class="btn" @click="setOption2()">保存设置</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import { level } from '@/config.js';
export default {
  components: {
    Header
  },
  name: 'currency-setting',
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '悦贝积分设置'
      },
      options: [],
      editOptions: {},
      loading: 0,
      role: level,
      role1: '',
      info1: {},
      info2: {}
    };
  },
  mounted() {
    // this.getOption1();
    // this.getOption2();
  },
  computed: {},
  methods: {
    setOption1() {
      this.loading++;
      this.httpPut(this.$root.setUserSetting1, {
        ...this.info1
      }).then(
        (res) => {
          this.$message.success('操作成功');
          this.loading--;
          this.getOption1();
        },
        (res) => {
          this.$message.error(res);
          this.loading--;
        }
      );
    },
    setOption2() {
      this.loading++;
      this.httpPut(this.$root.setUserSetting2, {
        ...this.info2
      }).then(
        (res) => {
          this.$message.success('操作成功');
          this.loading--;
          this.getOption2();
        },
        (res) => {
          this.$message.error(res);
          this.loading--;
        }
      );
    },
    getOption1() {
      this.loading++;
      this.httpGet(this.$root.getUserSettingInfo1).then(
        (res) => {
          this.loading--;
          this.info1 = {
            oneDirectVip: res.oneDirectVip,
            oneDirectTeam: res.oneDirectTeam,
            twoNumber: res.twoNumber,
            twoRole: res.twoRole,
            threeNumber: res.threeNumber,
            threeRole: res.threeRole,
            fourNumber: res.fourNumber,
            fourRole: res.fourRole
          };
        },
        (res) => {
          this.$message.error(res);
          this.loading--;
        }
      );
    },
    getOption2() {
      this.loading++;
      this.httpGet(this.$root.getUserSettingInfo2).then(
        (res) => {
          this.loading--;
          this.info2 = {
            roleOne: res.roleOne,
            roleTwo: res.roleTwo,
            roleThree: res.roleThree,
            roleFour: res.roleFour,
            stockFive: res.stockFive,
            stockSix: res.stockSix
          };
        },
        (res) => {
          this.$message.error(res);
          this.loading--;
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.currency-setting-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      // padding: 24px;
      border-radius: 2px;
      background: #F6F6F6;
      flex-x(space-between, flex-start);
      flex-wrap: wrap;

      .item {
        background: #fff;
        width: 49.5%;
        padding: 24px;
        box-sizing: border-box;
        overflow: hidden;
        flex-shrink: 1;
        margin-bottom: 12px;

        &.item2 {
          width: 100%;
        }

        // float: right;
        .title {
          word(20px, #333);
          flex-x();
        }

        .form {
          padding-left: 80px;
          margin-top: 36px;

          .input-box {
            min-height: 48px;
            flex-x(flex-start, center);

            .label {
              width: 180px;
              height: 48px;
              line-height: 48px;
              align-self: flex-start;
            }

            .input {
              height: 32px;
              width: 150px;
              border: 1px solid #D9D9D9;
              border-radius: 4px;
              padding: 0 12px;
              box-sizing: border-box;
            }
          }

          .item-input {
            flex-y(center, flex-start);
            line-height: 32px;

            span {
              margin-right: 6px;
            }
          }

          .tip {
            word(12px, #A6A6A6);
            // padding-left: 180px;
            padding-bottom: 3px;
            line-height: 32px;
          }
        }

        .btn {
          width: 145px;
          height: 32px;
          confirm-btn();
          flex-x(center);
          margin-top: 32px;
          margin-left: 80px;
        }
      }
    }
  }
}
</style>
